import { Outlet, useLocation } from 'react-router-dom'
import { Suspense } from 'react'
import Footer from './Footer'
import { useAuth } from '@/app/providers/AuthProvider'

function Layout() {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  const authPaths = [
    '/login',
    '/register',
    '/forgot-password',
    '/verify-otp',
    '/remote-login',
    '/'
  ]

  const isAuthPage = authPaths.includes(location.pathname) || location.pathname.startsWith('/confirm-password')

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1">
        <Suspense fallback={<div className="min-h-screen" />}>
          <Outlet />
        </Suspense>
      </main>

      {(!isLoading && !user || isAuthPage) && <Footer />}
    </div>
  )
}

export default Layout;
